import { render, staticRenderFns } from "./CustomerOpportunitiesTab.vue?vue&type=template&id=856b23f4&scoped=true&"
import script from "./CustomerOpportunitiesTab.vue?vue&type=script&lang=js&"
export * from "./CustomerOpportunitiesTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOpportunitiesTab.vue?vue&type=style&index=0&id=856b23f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b23f4",
  null
  
)

export default component.exports